import { Auth0Provider, type AppState } from '@auth0/auth0-react';
import type { ReactNode } from 'react';
import { getAuth0Config } from './auth0-config';

/**
 * Auth0Provider wrapper.
 *
 * Post-callback navigation: używa `window.history.replaceState` + `popstate` event
 * (zamiast TanStack Router useNavigate, ponieważ Auth0Provider mount jest NA ZEWNĄTRZ
 * RouterProvider — router hooks nie są jeszcze available). To trigger'uje router
 * re-render bez full page reload.
 */
export function Auth0ProviderWithRouter({ children }: { children: ReactNode }) {
  const config = getAuth0Config();

  const onRedirectCallback = (appState?: AppState) => {
    const returnTo = appState?.returnTo ?? '/dashboard';
    // Clean URL (remove ?code=, ?state=) without adding history entry.
    window.history.replaceState({}, document.title, returnTo);
    // Trigger router re-render through history navigation API.
    window.dispatchEvent(new PopStateEvent('popstate'));
  };

  return (
    <Auth0Provider
      domain={config.domain}
      clientId={config.clientId}
      authorizationParams={{
        redirect_uri: config.redirectUri,
        audience: config.audience,
        scope: config.scope,
      }}
      cacheLocation={config.cacheLocation}
      useRefreshTokens={config.useRefreshTokens}
      onRedirectCallback={onRedirectCallback}
    >
      {children}
    </Auth0Provider>
  );
}
